import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Log para debug (apenas em desenvolvimento)
    if (process.env.NODE_ENV === 'development') {
      console.log('📤 Requisição API:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        baseURL: config.baseURL,
        hasToken: !!token
      });
    }
    
    return config;
  },
  (error) => {
    console.error('❌ Erro no interceptor de requisição:', error);
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de autenticação e rede
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Erro de autenticação
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    
    // Erro de rede (Network Error)
    if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
      console.error('❌ Erro de rede:', {
        message: error.message,
        code: error.code,
        url: error.config?.url,
        baseURL: error.config?.baseURL || api.defaults.baseURL,
        method: error.config?.method?.toUpperCase(),
        hasToken: !!error.config?.headers?.Authorization
      });
      
      // Sugestão para o usuário
      console.warn('💡 Possíveis causas:');
      console.warn('   1. Servidor não está rodando');
      console.warn('   2. URL base está incorreta:', api.defaults.baseURL);
      console.warn('   3. Problema de CORS ou DNS (financas360-api.local)');
      console.warn('   4. Firewall bloqueando a conexão');
    }
    
    return Promise.reject(error);
  }
);

export default api;
